import axios from 'axios';
import * as Sentry from '@sentry/react';

import { INITIAL_STATE as safetyObservationState } from '../store/safetyObservation/safetyObservation.reducer';
import { INITIAL_FORM_STATE as safetyInspectionState } from '../store/safetyInspection/safetyInspection.reducer';
import moment from 'moment';

export const getSafetyFormSubmission = async (id, sid) =>
	axios
		.get(`/forms_rest_api/${id}/${sid}`)
		.then(({ data }) => {
			switch (id) {
				case 'safety_observation': {
					const activity = Object.entries(safetyObservationState.activity).reduce((acc, [field, value]) => {
						acc[field] = {
							...value,
							value: data.activity.includes(field)
						};

						return acc;
					}, {});

					const type_of_observation = Object.entries(safetyObservationState.type_of_observation).reduce(
						(acc, [field, value]) => {
							acc[field] = {
								...value,
								value: data.type_of_observation === field
							};

							return acc;
						},
						{}
					);

					const conditions = Object.entries(safetyObservationState.conditions).reduce(
						(acc, [field, value]) => {
							value.fields = Object.entries(value.fields).reduce((_acc, [_field, _value]) => {
								_acc[_field] = {
									..._value,
									safe: data?.[_field]?.[0] === 'safe',
									concern: data?.[_field]?.[0] === 'concern'
								};

								return _acc;
							}, {});

							acc[field] = value;

							return acc;
						},
						{}
					);

					const near_misses = Object.entries(safetyObservationState.near_misses).reduce(
						(acc, [field, value]) => {
							acc[field] = {
								...value,
								value: data.near_misses?.includes(field) || false
							};

							return acc;
						},
						{}
					);

					return {
						id,
						sid,
						activity,
						type_of_observation,
						conditions,
						what: data.what,
						why: data.why,
						on_site_solution: data.on_site_solution,
						hazard_status: {
							...safetyObservationState.hazard_status,
							[data.hazard_status]: true
						},
						hazard_status_comment: data.comment,
						near_misses,
						near_miss_description: data.near_miss_description,
						project_location: data.project_location,
						observer_name: data.observer_name,
						date: {
							...safetyObservationState.date,
							date: moment(data.date).valueOf()
						},
						photos: data.photos || []
					};
				}
				case 'safety_inspection': {
					const info = Object.entries(safetyInspectionState.info).reduce((acc, [field, value]) => {
						acc[field] = {
							...value,
							value: field === 'date' ? Math.floor(moment(data[field]).valueOf() / 1000) : data[field]
						};

						return acc;
					}, {});

					const observations = Object.entries(safetyInspectionState.observations).reduce(
						(acc, [field, value]) => {
							acc[field] = {
								...value,
								fields: Object.entries(value.fields).reduce((_acc, [_field, _value]) => {
									_acc[_field] = {
										..._value,
										[data[_field]]: true
									};

									return _acc;
								}, {})
							};

							return acc;
						},
						{}
					);

					const unsafe_acts_procedure_deviations = {
						fields: Object.entries(safetyInspectionState.unsafe_acts_procedure_deviations.fields).reduce(
							(acc, [field, value]) => {
								acc[field] = {
									...value,
									yes: data[field] === 'y',
									no: data[field] === 'n'
								};

								return acc;
							},
							{}
						),
						additional_act_procedure:
							data.additional_act_procedure?.map(({ act_procedure, yes_no }) => ({
								title: act_procedure,
								yes: yes_no === 'y',
								no: yes_no === 'n'
							})) || []
					};

					return {
						id,
						sid,
						info,
						observations,
						unsafe_acts_procedure_deviations,
						comments: data.comments,
						violations: data.violations.map(({ description, major_moderate_minor }) => ({
							description,
							majorModerateMinor:
								major_moderate_minor.charAt(0).toUpperCase() + major_moderate_minor.slice(1)
						}))
					};
				}
				default:
					return data;
			}
		})
		.catch(error => {
			Sentry.captureException(error);
			throw error;
		});

export const saveSafetyObservation = (sid, form) =>
	axios
		.patch('/forms_rest_api/safety_observation/' + sid, form, { headers: { 'Content-Type': 'application/json' } })
		.catch(error => {
			Sentry.captureException(error);
			throw error;
		});

export const saveSafetyInspection = (sid, form) =>
	axios
		.patch('/forms_rest_api/safety_inspection/' + sid, form, { headers: { 'Content-Type': 'application/json' } })
		.catch(error => {
			Sentry.captureException(error);
			throw error;
		});

export const searchSafetyDatabase = form =>
	axios
		.post('/forms_rest_api/safety_database', form, {
			headers: { 'Content-Type': 'application/json' }
		})
		.catch(error => {
			Sentry.captureException(error);
			throw error;
		});
